import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import UserTotal from './UserTotal';
import { makeSelectTotalUser } from '~/containers/HomePage/selectors';

const mapStateToProps = createStructuredSelector({
  totalUser: makeSelectTotalUser(),
});
export default connect(mapStateToProps)(UserTotal);
